import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { UserService } from '../../../../app/services/user.service';

interface StatsViewModel {
  iqr: number;
  accumulated: number;
  currentDate: Date;
  startDate: Date;
  monthlyHistory: {
    date: Date;
    accumulated: number;
    iqr: number;
  }[];
  notAvailable: Date[];
}

@Component({
  selector: 'app-stats',
  templateUrl: './stats.page.html',
  styleUrls: ['./stats.page.scss'],
})
export class StatsPage implements OnInit, OnDestroy {

  viewModel: StatsViewModel;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getUser()
      .pipe(
        takeUntil(this.destroyed$),
        map(({ stats: { monthly, now, iqr, accumulated } }) => {
          const monthsKeys = [...Array(12).keys()].map(key => `${now.getUTCFullYear()}${String(key + 1).padStart(2, '0')}`);
          const monthDate = (key: string) => {
            const year = Number(key.substr(0, 4));
            const month = Number(key.substr(4, 2)) - 1;
            return new Date(year, month, 1, 12, 0, 0);
          };
          return {
            iqr,
            accumulated,
            startDate: new Date(now.getUTCFullYear(), 0, 1, 12, 0, 0),
            currentDate: now,
            monthlyHistory: monthsKeys.filter(key => monthly[key]).reverse().map(key => ({
                date: monthDate(key),
                iqr: monthly[key].iqr,
                accumulated: monthly[key].accumulated
              })),
            notAvailable: monthsKeys.filter(key => !monthly[key]).map(key => monthDate(key))
          };
        })
      ).subscribe(viewModel => {
        this.viewModel = viewModel;
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
